import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=b5b72576&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports